import React from 'react';
const { useState, useEffect } = React;
import { coachCall } from './shared.jsx';
import { ASSIGNMENT_KINDS, label } from '../../coachingConfig.js';
import { LoadingState, ErrorState } from '../ui/States.jsx';

// Gestión de clientes › Actividades y entregas (only the coach; coaching-admin checks it on every call). Two lists that
// are never mixed, each from its own records and states:
// - «Por hacer»: process activities still to do (Coaching Assignments, Status = assigned): pending for the person (or
//   for the team), not for Ale. Done is the participant's own mark; nothing here is reviewed. (pendingActivities)
// - «Por revisar»: course work submitted and waiting for her feedback (Coaching Submissions, submitted): the same
//   queue as Cursos and Hoy › Por atender. (learningOverview › review)
// Each item opens its process or its submission; only identifying data is listed (never instructions or answers).

const muted = { fontSize: 12, color: 'var(--globant-muted)' };
const box = { border: '1px solid var(--globant-border)', borderRadius: 10, padding: '10px 12px', display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center', background: 'var(--globant-card, #fff)' };
const fmt = (d) => (d ? new Date(d.length === 10 ? `${d}T12:00:00Z` : d).toLocaleDateString('es', { day: 'numeric', month: 'short', timeZone: d.length === 10 ? 'UTC' : undefined }) : '');
const todayIso = () => new Date().toISOString().slice(0, 10);

function useSource(call) {
  const [s, setS] = useState({ data: null, error: '' });
  const load = () => { setS(x => ({ ...x, error: '' })); call().then(data => setS({ data, error: '' })).catch(e => setS({ data: null, error: e.message || 'No se pudo leer.' })); };
  useEffect(load, []);
  return [s, load];
}

export default function ActivitiesAndDeliveries({ onOpenProcess, onOpenSubmission }) {
  const [todo, reloadTodo] = useSource(() => coachCall({ action: 'pendingActivities' }));
  const [review, reloadReview] = useSource(() => coachCall({ action: 'learningOverview' }));
  const today = todayIso();
  const acts = todo.data?.activities || [];
  const subs = review.data?.review || [];
  return (
    <div style={{ display: 'grid', gap: 22 }}>
      <section aria-labelledby="ad-review">
        <h3 id="ad-review" style={{ margin: '0 0 2px' }}>Por revisar · trabajos entregados{review.data ? ` (${subs.length})` : ''}</h3>
        <div style={{ ...muted, marginBottom: 8 }}>Entregas de cursos que esperan tu devolución. Es la misma cola que en Cursos y en Hoy.</div>
        {review.error ? <ErrorState message={`${review.error} No significa que no haya entregas.`} onRetry={reloadReview} />
          : !review.data ? <LoadingState />
          : !subs.length ? <div style={{ ...box, ...muted }}>No hay trabajos esperando tu revisión.</div>
          : <div style={{ display: 'grid', gap: 6 }}>{subs.map(r => (
            <div key={r.id} style={box}>
              <div style={{ flex: '1 1 260px', minWidth: 0 }}><b>{r.personName}</b> · {r.lessonTitle}<div style={muted}>{r.courseName} · entrega {r.attempt}{r.attempt > 1 ? ' (corregida)' : ''}{r.submittedAt ? ` · ${fmt(r.submittedAt)}` : ''}</div></div>
              <button type="button" className="action-btn btn-primary" style={{ fontSize: 12 }} onClick={() => onOpenSubmission(r)}>Revisar</button>
            </div>
          ))}</div>}
      </section>
      <section aria-labelledby="ad-todo">
        <h3 id="ad-todo" style={{ margin: '0 0 2px' }}>Por hacer · actividades de los procesos{todo.data ? ` (${acts.length})` : ''}</h3>
        <div style={{ ...muted, marginBottom: 8 }}>Actividades asignadas que la persona (o el equipo) todavía no marcó como hechas. No esperan tu revisión: están pendientes de hacer.</div>
        {todo.error ? <ErrorState message={`${todo.error} No significa que no haya actividades.`} onRetry={reloadTodo} />
          : !todo.data ? <LoadingState />
          : !acts.length ? <div style={{ ...box, ...muted }}>No hay actividades pendientes en tus procesos.</div>
          : <div style={{ display: 'grid', gap: 6 }}>{acts.map(a => (
            <div key={a.id} style={box}>
              <div style={{ flex: '1 1 260px', minWidth: 0 }}>
                <b>{a.name}</b> <span style={muted}>· {label(ASSIGNMENT_KINDS, a.kind)}</span>
                <div style={muted}>{a.team ? 'Del equipo' : a.personName || 'Persona sin nombre'} · {a.processName || 'Proceso'}{a.dueOn ? ` · para el ${fmt(a.dueOn)}` : ' · sin fecha'}{a.dueOn && a.dueOn < today ? ' · vencida' : ''}</div>
              </div>
              <button type="button" className="action-btn" style={{ fontSize: 12 }} onClick={() => onOpenProcess(a.processId, { tab: 'activities' })}>Abrir en su proceso</button>
            </div>
          ))}</div>}
      </section>
    </div>
  );
}
